// src/services/discounts.api.js
import { apiRequest } from "./api";

export const getActiveOrderDiscount = () => {
  return apiRequest("/discounts/order-discount");
};

export const getActiveFreeShippingDiscount = () => {
  return apiRequest("/discounts/free-shipping");
};